import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import Player from '@vimeo/player'
import { module as BaseModule } from 'modujs'

gsap.registerPlugin(ScrollTrigger)

export default class extends BaseModule {
  init () {
    const connection =
      navigator.connection ||
      navigator.mozConnection ||
      navigator.webkitConnection

    if (connection && connection.effectiveType !== '4g') {
      window.debug('skipping live not 4g')
      return
    }

    this.setPlayers()
    this.setVimeos()
  }

  setPlayers () {
    // window.debug('autoplay intersection observer for html video')

    const options = {
      root: null,
      rootMargin: '0px',
      treshold: 0
    }

    const callback = entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const video = entry.target
          const isPlaying =
            video.currentTime > 0 &&
            !video.paused &&
            !video.ended &&
            video.readyState > video.HAVE_CURRENT_DATA
          if (!isPlaying) {
            video.play()
          }
        } else {
          // console.log(entry.target, 'pause')
          entry.target.pause()
        }
      })
    }

    const observer = new IntersectionObserver(callback, options)
    const videos = document.querySelectorAll('video')

    videos.forEach(video => {
      observer.observe(video)
    })
  }

  setVimeos () {
    const videos = document.querySelectorAll('.c-live__video iframe')
    videos.forEach(video => {
      let state = false

      const player = new Player(video)

      const play = async () => {
        // console.log('play', state)
        try {
          if (state) return
          await player.play()
          state = true
          // console.log(state)
        } catch (error) {
          throw new Error(error)
        }
      }

      const pause = async () => {
        // console.log('pause', state)
        try {
          if (!state) return
          await player.pause()
          state = false
        } catch (error) {
          throw new Error(error)
        }
      }

      const options = {
        root: null,
        rootMargin: '0px'
      }

      const callback = entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            play()
          } else {
            pause()
          }
        })
      }

      const observer = new IntersectionObserver(callback, options)
      observer.observe(video)
    })
  }
}
